// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
.tabControl {
  height: 100%;
}

.tabControl .tabHeader {
  height: 41px;
  background: var(--tab-White);
  border-radius: 6px;
}

.templateContent .tabHeader {
  background-color: unset;
  margin-left: 0px;
}

.tabControl .tabHeader .tabHeaderTabs,
.tabControl .tabHeader .MuiTouchRipple-root,
.tabControl .tabHeader .tabHeaderTab,
.tabControl .tabHeader .MuiTab-root,
.tabControl .tabHeader .MuiTabs-flexContainer {
  min-height: 41px;
  height: 41px;
  min-width: 0px;
}

.tabControl .tabHeader .MuiTabs-flexContainer {
  gap: 10px;
}

.tabControl .tabHeader .tabHeaderTab {
  padding: 0px;
}

/* Splitted padding of tab header button with tab header button text - to make selected tab underline fit to text with edge 4px -- start */
.templateContent
  .tabControl
  .tabHeader
  .MuiButtonBase-root.Mui-selected
  div.tabTitleButton {
  border-bottom: var(--unStyledSwitchColor) 4px solid;
  border-radius: 0px;
}

.templateContent .tabControl .tabHeader .tabHeaderTab {
  padding: 10px 0px 10px 0px;
}

.templateContent .tabControl .tabHeader .tabTitleButton {
  padding-right: 4px;
  padding-left: 4px;
}

.templateContent
  .tabControl
  .tabHeader
  .MuiButtonBase-root.Mui-selected
  .tabTitleButton.contained {
  padding-bottom: 6px;
}

/* Splitted padding of tab header button with tab header button text - to make selected tab underline fit to text with edge 4px -- end */

.tabControl .tabHeader .tabTitleButton {
  height: 41px;
  padding: 10px 16px;
  border-radius: 6px;
  text-transform: none;
  font-family: var(--default-FontName);
  font-weight: var(--header-FontWeight);
  font-size: var(--default-FontSize);
  display: inline-flex;
  align-items: center;
  line-height: 21px;
}

.templateContent .tabControl .tabHeader .tabTitleButton {
  font-size: var(--additionalTabSideHead);
}

/*Normal Tab*/
.tabControl .tabHeader .tabTitleButton.text {
  color: var(--listHeaderFontColor);
}

/*Disabled Tab*/
.tabControl .tabHeader .MuiButtonBase-root.Mui-disabled {
  opacity: 0.45;
  pointer-events: auto !important;
  cursor: not-allowed !important;
}

.tabControl .tabHeader .MuiButtonBase-root.Mui-disabled .tabTitleButton.text,
.tabControl
  .tabHeader
  .MuiButtonBase-root.Mui-disabled
  .tabTitleButton.contained {
  color: #9e9e9e;
  background-color: transparent;
}

/*Active Tab*/
.tabHeader .tabTitleButton.contained {
  background-color: var(--button-color);
  color: var(--tooltipFontColor);
}

.templateContent .tabHeader .tabTitleButton.contained {
  background: unset;
  color: var(--listHeaderFontColor);
}

.templateContent .tabHeader .Mui-selected .tabTitleButton.contained {
  /* background: unset; */
  color: var(--templateHeaderSelectedFontColor);
}

.tabHeader .MuiTabs-indicator {
  display: none;
}

.tabControl .tabContent {
  overflow: auto;
  height: calc(100% - 41px);
}
.tabControl .tabHeader .hideTheTab {
  display: none;
}

.tabControl .tabHeader .favouriteIcon {
  width: 20px;
  cursor: pointer;
}

.tabControl .tabHeader .iconPlaceholder {
  width: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/views/components/base/tabControl/TabControl.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;;;;EAKE,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA,0IAA0I;AAC1I;;;;;EAKE,mDAAmD;EACnD,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;;;EAKE,mBAAmB;AACrB;;AAEA,wIAAwI;;AAExI;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,oCAAoC;EACpC,qCAAqC;EACrC,kCAAkC;EAClC,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;AACzC;;AAEA,aAAa;AACb;EACE,iCAAiC;AACnC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;;;;;EAKE,cAAc;EACd,6BAA6B;AAC/B;;AAEA,aAAa;AACb;EACE,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;AACb","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n.tabControl {\n  height: 100%;\n}\n\n.tabControl .tabHeader {\n  height: 41px;\n  background: var(--tab-White);\n  border-radius: 6px;\n}\n\n.templateContent .tabHeader {\n  background-color: unset;\n  margin-left: 0px;\n}\n\n.tabControl .tabHeader .tabHeaderTabs,\n.tabControl .tabHeader .MuiTouchRipple-root,\n.tabControl .tabHeader .tabHeaderTab,\n.tabControl .tabHeader .MuiTab-root,\n.tabControl .tabHeader .MuiTabs-flexContainer {\n  min-height: 41px;\n  height: 41px;\n  min-width: 0px;\n}\n\n.tabControl .tabHeader .MuiTabs-flexContainer {\n  gap: 10px;\n}\n\n.tabControl .tabHeader .tabHeaderTab {\n  padding: 0px;\n}\n\n/* Splitted padding of tab header button with tab header button text - to make selected tab underline fit to text with edge 4px -- start */\n.templateContent\n  .tabControl\n  .tabHeader\n  .MuiButtonBase-root.Mui-selected\n  div.tabTitleButton {\n  border-bottom: var(--unStyledSwitchColor) 4px solid;\n  border-radius: 0px;\n}\n\n.templateContent .tabControl .tabHeader .tabHeaderTab {\n  padding: 10px 0px 10px 0px;\n}\n\n.templateContent .tabControl .tabHeader .tabTitleButton {\n  padding-right: 4px;\n  padding-left: 4px;\n}\n\n.templateContent\n  .tabControl\n  .tabHeader\n  .MuiButtonBase-root.Mui-selected\n  .tabTitleButton.contained {\n  padding-bottom: 6px;\n}\n\n/* Splitted padding of tab header button with tab header button text - to make selected tab underline fit to text with edge 4px -- end */\n\n.tabControl .tabHeader .tabTitleButton {\n  height: 41px;\n  padding: 10px 16px;\n  border-radius: 6px;\n  text-transform: none;\n  font-family: var(--default-FontName);\n  font-weight: var(--header-FontWeight);\n  font-size: var(--default-FontSize);\n  display: inline-flex;\n  align-items: center;\n  line-height: 21px;\n}\n\n.templateContent .tabControl .tabHeader .tabTitleButton {\n  font-size: var(--additionalTabSideHead);\n}\n\n/*Normal Tab*/\n.tabControl .tabHeader .tabTitleButton.text {\n  color: var(--listHeaderFontColor);\n}\n\n/*Disabled Tab*/\n.tabControl .tabHeader .MuiButtonBase-root.Mui-disabled {\n  opacity: 0.45;\n  pointer-events: auto !important;\n  cursor: not-allowed !important;\n}\n\n.tabControl .tabHeader .MuiButtonBase-root.Mui-disabled .tabTitleButton.text,\n.tabControl\n  .tabHeader\n  .MuiButtonBase-root.Mui-disabled\n  .tabTitleButton.contained {\n  color: #9e9e9e;\n  background-color: transparent;\n}\n\n/*Active Tab*/\n.tabHeader .tabTitleButton.contained {\n  background-color: var(--button-color);\n  color: var(--tooltipFontColor);\n}\n\n.templateContent .tabHeader .tabTitleButton.contained {\n  background: unset;\n  color: var(--listHeaderFontColor);\n}\n\n.templateContent .tabHeader .Mui-selected .tabTitleButton.contained {\n  /* background: unset; */\n  color: var(--templateHeaderSelectedFontColor);\n}\n\n.tabHeader .MuiTabs-indicator {\n  display: none;\n}\n\n.tabControl .tabContent {\n  overflow: auto;\n  height: calc(100% - 41px);\n}\n.tabControl .tabHeader .hideTheTab {\n  display: none;\n}\n\n.tabControl .tabHeader .favouriteIcon {\n  width: 20px;\n  cursor: pointer;\n}\n\n.tabControl .tabHeader .iconPlaceholder {\n  width: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
